module.exports = __webpack_public_path__ + "static/cardpattern-f635f7f3bdcc819e76c274e81b6f84b8.png";